export const SerieTypeEnum = {
    STATIQUE: 'STATIQUE',
    DYNAMIQUE: 'DYNAMIQUE',
    ALEATOIRE: 'ALEATOIRE'
};